import React from 'react';
import { Form, Input, Modal, Space, Switch, Typography } from 'antd';
import { TagsOutlined } from '@ant-design/icons';
const { Text } = Typography;

const ModalConfiguracionCartera = ({ isModalTarifasOpen, setIsModalTarifasOpen, formTarifas, configLoading, handleGuardarTarifas }) => {
    return (
        <Modal
            title={
                <Space size="middle" align="center">
                    <div style={{ background: '#e0f2fe', padding: '10px', borderRadius: '12px', display: 'flex' }}>
                        <TagsOutlined style={{ color: '#0284c7', fontSize: '22px' }} />
                    </div>
                    <span style={{ fontSize: '20px', fontWeight: '900', color: '#0f172a' }}>Listas de Precios</span>
                </Space>
            }
            open={isModalTarifasOpen}
            onCancel={() => setIsModalTarifasOpen(false)}
            onOk={() => formTarifas.submit()}
            confirmLoading={configLoading}
            width={550}
            centered
            className="modal-tarifas-yugonub"
            cancelText="CANCELAR"
            cancelButtonProps={{ style: { height: '45px', borderRadius: '10px', fontWeight: '600', padding: '0 20px' } }}
            okText="GUARDAR CAMBIOS"
            okButtonProps={{ style: { backgroundColor: '#22BABB', height: '45px', borderRadius: '10px', fontWeight: 'bold', border: 'none', padding: '0 20px' } }}
            styles={{ body: { paddingTop: '15px' } }}
        >
            {/* Estilos forzados para arreglar el contraste de los Switch en este modal */}
            <style>{`
                .modal-tarifas-yugonub .ant-switch {
                    background-color: #94a3b8 !important; /* Gris oscuro para estado Inactivo */
                    min-width: 75px; /* Un poco más ancho para que quepa bien la palabra */
                }
                .modal-tarifas-yugonub .ant-switch-checked {
                    background-color: #0ea5e9 !important; /* Azul para estado Activo */
                }
                .modal-tarifas-yugonub .ant-switch-inner {
                    color: #ffffff !important;
                    font-weight: 600;
                    font-size: 13px;
                }
            `}</style>

            <Form form={formTarifas} layout="vertical" onFinish={handleGuardarTarifas}>
                {[1, 2, 3].map((num) => (
                    <div key={num} style={{ background: '#f8fafc', padding: '20px', borderRadius: '16px', marginBottom: '15px', border: '1px solid #e2e8f0' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                            <Text strong style={{ fontSize: '16px', color: '#334155' }}>Lista de Precios {num}</Text>
                            <Form.Item name={`lista_${num}_activa`} valuePropName="checked" noStyle>
                                <Switch checkedChildren="Activa" unCheckedChildren="Oculta" />
                            </Form.Item>
                        </div>
                        <Form.Item name={`lista_${num}_nombre`} style={{ marginBottom: 0 }}>
                            <Input
                                style={{ height: '45px', borderRadius: '10px', fontSize: '15px', fontWeight: '600' }}
                                placeholder={`Ej: Precio ${num === 1 ? 'Mayorista' : num === 2 ? 'Distribuidor' : 'Empleados'}`}
                            />
                        </Form.Item>
                    </div>
                ))}
            </Form>
        </Modal>
    )
}

export default ModalConfiguracionCartera;